import React, { useState } from 'react';

import Svg from "../../../src/assets/icons/icons.js"

import {
    WrapAboutSt,
    ItemSt,
    WrapTopSt,
    HeaderSt,
    TextSt,
    LogoSt,
    IconSt,
    WrapMobSt
} from './style.js'

import i18n from "i18next";

const AccountProject = ({ logoCompany, aboutCompany }) => {
    const [textIsOpen, setTextIsOpen] = useState(false);

    const handleClickOpen = () => {
        setTextIsOpen((prev) => !prev);
    };

    return (
        <WrapAboutSt>
            <ItemSt>
                <WrapTopSt onClick={() => handleClickOpen()}>
                    <HeaderSt>{i18n.t(`profile.about_company_b`)}</HeaderSt>
                    <IconSt className={textIsOpen ? "close" : null}>
                        <Svg type="keyboard_arrow" width="24" height="24" />
                    </IconSt>
                </WrapTopSt>
                <WrapMobSt className={textIsOpen ? null : "close"}>
                    <TextSt >{aboutCompany}</TextSt>
                </WrapMobSt>
            </ItemSt>

            <ItemSt>
                {logoCompany &&
                    <LogoSt>
                        <img src={logoCompany} alt="Логотип компании" />
                    </LogoSt>
                }
            </ItemSt>
        </WrapAboutSt>
    );
};

export default AccountProject;
